import React, { useContext } from 'react'
import { MenuProps } from '@mui/material/Menu'
import { bindFocus, bindHover, usePopupState } from 'material-ui-popup-state/hooks'
import MenuItem from '@mui/material/MenuItem'
import makeStyles from '@mui/styles/makeStyles'

import { Text } from 'components/shared'
import { CascadingContext } from './index'
import CascadingMenu from './CascadingMenu'

const useCascadingMenuStyles = makeStyles(theme => ({
  submenu: {
    marginTop: theme.spacing(-1),
  },
  title: {
    flexGrow: 1,
  },
  moreArrow: {
    marginRight: theme.spacing(-1),
  },
  menuItem: {
    backgroundColor: ({ isOpen }: { isOpen?: boolean }) => (isOpen ? theme.palette.action.hover : 'transparent'),
  },
}))

interface ICascadingSubmenu extends Partial<MenuProps> {
  title: string
  popupId: string | null | undefined
  onClick: () => void
}

const CascadingSubmenu = ({ title, popupId, ...props }: ICascadingSubmenu) => {
  const { parentPopupState } = useContext(CascadingContext)
  const popupState = usePopupState({
    popupId,
    variant: 'popover',
    parentPopupState,
  })
  const classes = useCascadingMenuStyles({ isOpen: popupState?.isOpen })
  return (
    <>
      <MenuItem
        {...bindHover(popupState)}
        {...bindFocus(popupState)}
        className={classes.menuItem}
        onClick={props.onClick}
      >
        <Text size={'sm'} className={classes.title}>
          {title}
        </Text>
        <svg width="16px" height="16px" style={{ transform: 'rotate(-90deg)' }} className={classes.moreArrow}>
          <use xlinkHref="#triangle" />
        </svg>
      </MenuItem>
      <CascadingMenu
        {...props}
        classes={{ ...props.classes, paper: classes.submenu }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        popupState={popupState}
      />
    </>
  )
}

export default CascadingSubmenu
